import script from "./OTPForm.vue?vue&type=script&setup=true&lang=js"
export * from "./OTPForm.vue?vue&type=script&setup=true&lang=js"

import "./OTPForm.vue?vue&type=style&index=0&id=041c277d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-041c277d"]])

export default __exports__